export const CONTENT_TAREFA_KEYS = {
  DETALHAR_PROCESSO: "detalhar-processo",
  PESQUISAR_PROCESSOS_FAZENDO: "pesquisar-processos-fazendo",
  PESQUISAR_PROCESSOS_FINALIZADOS: "pesquisar-processos-finalizados",
  PESQUISAR_TAREFAS_PARA_FAZER: "pesquisar-tarefas-para-fazer",
} as const;